"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passengerIncidentLabel = exports.RefuseMtManualInvoiceReasonLabel = exports.CustomizationStateLabel = exports.paymentStatusLabel = exports.GovFlatRateDistanceLabel = exports.getFlatFeeTypeLabel = void 0;
exports.getGovFlatRateDistanceLabel = getGovFlatRateDistanceLabel;
exports.getGovFlatRateMfdTypeLabel = getGovFlatRateMfdTypeLabel;
exports.getGovFlatRateLabel = getGovFlatRateLabel;
var _1 = require(".");
var gov_flat_rate_1 = require("./gov-flat-rate");
var flatFeeTypeLabel = {
    PRISE_EN_CHARGE: 'Prise en charge',
    DEPARTEMENTAL: 'Forfait départemental',
    AGGLOMERATION: 'Forfait agglomération',
    A: 'Forfait dép. zone A',
    B: 'Forfait dép. zone B',
    C: 'Forfait dép. zone C',
    D: 'Forfait dép. zone D',
    // * 67 & 69
    GOV_BASRHIN_AGGLOMERATION: null,
    GOV_BASRHIN_OUTSIDE: null,
    GOV_PATIENT_SUPPORT_AND_SLOW_WALKING: null,
};
var getFlatFeeTypeLabel = function (flatFeeType, options) {
    var _a, _b, _c, _d;
    var label = (_a = flatFeeTypeLabel[flatFeeType]) !== null && _a !== void 0 ? _a : 'Forfait Prise en Charge';
    var price = null;
    if ((options === null || options === void 0 ? void 0 : options.pricingType) && (options === null || options === void 0 ? void 0 : options.vehiclePricingType)) {
        price = (_d = (_c = (_b = (0, _1.getLatestGovPricing)(options === null || options === void 0 ? void 0 : options.vehiclePricingType, new Date(), options === null || options === void 0 ? void 0 : options.pricingType)) === null || _b === void 0 ? void 0 : _b.flatFees) === null || _c === void 0 ? void 0 : _c.find(function (f) { return f.type === flatFeeType; })) === null || _d === void 0 ? void 0 : _d.price;
    }
    return "".concat(label).concat(price ? " (".concat((0, _1.formatCents)(price), ")") : '');
};
exports.getFlatFeeTypeLabel = getFlatFeeTypeLabel;
function getGovFlatRateDistanceLabel(govFlateRate) {
    if (!govFlateRate) {
        return '';
    }
    switch (govFlateRate) {
        case 'ST1_SSR':
        case 'ST1_PSY':
        case 'ST2_SSR':
        case 'ST2_PSY':
        case 'ST3_SSR':
        case 'ST3_PSY':
        case 'TDE_MCO':
        case 'TSE_MCO':
            return '';
        case 'ST1_SSR_0_25':
        case 'ST1_PSY_0_25':
        case 'TDE_MCO_0_25':
        case 'ST4_0_25':
            return '0-25km';
        case 'ST1_SSR_25_75':
        case 'ST1_PSY_25_75':
        case 'TDE_MCO_25_75':
        case 'ST4_25_75':
            return '25-75km';
        case 'ST1_SSR_75_150':
        case 'ST1_PSY_75_150':
        case 'TDE_MCO_75_150':
        case 'ST4_75_150':
            return '75-150km';
        case 'ST1_SSR_150_300':
        case 'ST1_PSY_150_300':
        case 'TDE_MCO_150_300':
        case 'ST4_150_300':
            return '150-300km';
        case 'ST1_SSR_300':
        case 'ST1_PSY_300':
        case 'TDE_MCO_300':
        case 'ST4_300':
            return '>300km';
        case 'ST2_SSR_0_20':
        case 'ST2_PSY_0_20':
        case 'ST3_SSR_0_20':
        case 'ST3_PSY_0_20':
        case 'ST5_0_20':
        case 'ST6_0_20':
            return '0-20km';
        case 'ST2_SSR_20_50':
        case 'ST2_PSY_20_50':
        case 'ST3_SSR_20_50':
        case 'ST3_PSY_20_50':
        case 'ST5_20_50':
        case 'ST6_20_50':
            return '20-50km';
        case 'ST2_SSR_50_120':
        case 'ST2_PSY_50_120':
        case 'ST3_SSR_50_120':
        case 'ST3_PSY_50_120':
        case 'ST6_50_120':
        case 'ST5_50_120':
            return '50-120km';
        case 'ST2_SSR_120':
        case 'ST2_PSY_120':
        case 'ST3_SSR_120':
        case 'ST3_PSY_120':
        case 'ST5_120':
        case 'ST6_120':
            return '>120km';
        case 'TSE_MCO_0_40':
            return '0-40km';
        case 'TSE_MCO_40_80':
            return '40-80km';
        case 'TSE_MCO_80_160':
            return '80-160km';
        case 'TSE_MCO_160':
            return '>160km';
    }
    (0, _1.assertUnreachable)(govFlateRate);
}
function getGovFlatRateMfdTypeLabel(govFlateRate) {
    if (!govFlateRate) {
        return '';
    }
    switch (govFlateRate) {
        case 'ST1_SSR':
        case 'ST2_SSR':
        case 'ST3_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 'SSR';
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'ST1_PSY_0_25':
        case 'ST1_PSY_25_75':
        case 'ST1_PSY_75_150':
        case 'ST1_PSY_150_300':
        case 'ST1_PSY_300':
        case 'ST2_PSY_0_20':
        case 'ST2_PSY_20_50':
        case 'ST2_PSY_50_120':
        case 'ST2_PSY_120':
        case 'ST3_PSY_0_20':
        case 'ST3_PSY_20_50':
        case 'ST3_PSY_50_120':
        case 'ST3_PSY_120':
            return 'PSY';
        case 'TDE_MCO':
        case 'TSE_MCO':
        case 'TDE_MCO_25_75':
        case 'TDE_MCO_0_25':
        case 'TDE_MCO_75_150':
        case 'TDE_MCO_150_300':
        case 'TDE_MCO_300':
        case 'TSE_MCO_0_40':
        case 'TSE_MCO_40_80':
        case 'TSE_MCO_80_160':
        case 'TSE_MCO_160':
            return 'MCO';
    }
    (0, _1.assertUnreachable)(govFlateRate);
}
function getGovFlatRateLabel(govFlateRate) {
    return [
        (0, gov_flat_rate_1.getGovFlatRateClass)(govFlateRate),
        getGovFlatRateMfdTypeLabel(govFlateRate),
        getGovFlatRateDistanceLabel(govFlateRate),
    ]
        .filter(Boolean)
        .join(' ');
}
exports.GovFlatRateDistanceLabel = {
    // Forfaits (ST1, TDE)
    ST1_SSR_0_25: 'De 0 km à 25 km non inclus',
    ST1_SSR_25_75: 'De 25 km à 75 km non inclus',
    ST1_SSR_75_150: 'De 75 km à 150 km non inclus',
    ST1_SSR_150_300: 'De 150 km à 300 km non inclus',
    ST1_SSR_300: '300 km et plus',
    ST1_PSY_0_25: 'De 0 km à 25 km non inclus',
    ST1_PSY_25_75: 'De 25 km à 75 km non inclus',
    ST1_PSY_75_150: 'De 75 km à 150 km non inclus',
    ST1_PSY_150_300: 'De 150 km à 300 km non inclus',
    ST1_PSY_300: '300 km et plus',
    // Forfaits (ST2, ST3)
    ST2_PSY_0_20: 'De 0 km à 20 km non inclus',
    ST2_PSY_20_50: 'De 20 km à 50 km non inclus',
    ST2_PSY_50_120: 'De 50 km à 120 km non inclus',
    ST2_PSY_120: '120 km et plus',
    ST2_SSR_0_20: 'De 0 km à 20 km non inclus',
    ST2_SSR_20_50: 'De 20 km à 50 km non inclus',
    ST2_SSR_50_120: 'De 50 km à 120 km non inclus',
    ST2_SSR_120: '120 km et plus',
    ST3_PSY_0_20: 'De 0 km à 20 km non inclus',
    ST3_PSY_20_50: 'De 20 km à 50 km non inclus',
    ST3_PSY_50_120: 'De 50 km à 120 km non inclus',
    ST3_PSY_120: '120 km et plus',
    ST3_SSR_0_20: 'De 0 km à 20 km non inclus',
    ST3_SSR_20_50: 'De 20 km à 50 km non inclus',
    ST3_SSR_50_120: 'De 50 km à 120 km non inclus',
    ST3_SSR_120: '120 km et plus',
    TDE_MCO_0_25: 'De 0 km à 25 km non inclus',
    TDE_MCO_25_75: 'De 25 km à 75 km non inclus',
    TDE_MCO_75_150: 'De 75 km à 150 km non inclus',
    TDE_MCO_150_300: 'De 150 km à 300 km non inclus',
    TDE_MCO_300: '300 km et plus',
    // Forfait TSE
    TSE_MCO_0_40: 'De 0 km à 40 km non inclus',
    TSE_MCO_40_80: 'De 40 km à 80 km non inclus',
    TSE_MCO_80_160: 'De 80 km à 160 km non inclus',
    TSE_MCO_160: '160 km et plus',
};
exports.paymentStatusLabel = {
    NOT_PAID: 'Non facturable',
    DI_HPTLA: "DI facturable à l'établissement",
    DI_HPTLB: "DI facturable à l'autre établissement",
    DI_HPTLA_HPTLB: "DI facturable à l'établissement refacturable à l'autre établissement",
    DI_HPTLA_PTNT: "DI facturable à l'établissement refacturable au patient",
    DI_AMBLER: 'DI facturable à Ambler',
    DI_PTNT: 'DI facturable au patient',
    HPTLA: "Facturable à l'établissement",
    HPTLB: "Facturable à l'autre établissement",
    PTNT: 'Facturable au patient',
    GOV: 'Facturable à la CPAM',
    AMBLER: 'Facturable à Ambler',
    HPTLA_PTNT: "Facturable à l'établissement refacturable au patient",
    HPTLA_HPTLB: "Facturable à l'établissement refacturable à l'autre établissement",
};
exports.CustomizationStateLabel = {
    USED: 'Afficher',
    USED_AND_REQUIRED: 'Afficher et obligatoire',
    UNUSED: 'Cacher',
};
exports.RefuseMtManualInvoiceReasonLabel = {
    METER_TICKET: 'Ticket compteur reçu à la place de la facture',
    VAT_ERROR: 'Erreur de TVA',
    INFORMATION_ERROR: 'Informations de facturation erronées',
    MISSING_INFORMATION: "Manque d'informations sur la facture",
    DOCUMENT_ERROR: 'Pièce jointe invalide',
    OTHER: 'Autre',
};
exports.passengerIncidentLabel = {
    HPTL_FLAG_DELAY: 'Le transporteur est en retard',
    HPTL_FLAG_PTNT_MISS: "Le patient a raté son RDV / transfert à cause d'un retard du transporteur",
    HPTL_FLAG_ORDER_ERROR: 'Erreur dans la commande',
    HPTL_FLAG_PTNT_LEFT: 'Le patient est parti par un autre moyen',
    HPTL_FLAG_NO_RETURN_RIDE: "Le transporteur n'a pas effectué le trajet",
    HPTL_FLAG_AUTO_LATE_CANCEL: "Annulation de l'établissement < 1h avant le départ",
    HPTL_FLAG_OTHER: 'Autre raison',
    HPTL_FLAG_OUTBOUND_DELAY: 'Le transporteur est en avance / retard',
    HPTL_FLAG_INBOUND_DELAY: 'Le transporteur a fait attendre le patient',
    HPTL_FLAG_MT_MISCONDUCT: 'Mauvais comportement du transporteur',
    HPTL_FLAG_ORDER_INSTRUCTIONS_NOT_RESPECTED: "Le transporteur n'a pas respecté les informations de la commande",
    HPTL_FLAG_MT_NO_SHOW: "Le transporteur ne s'est pas présenté",
    HPTL_FLAG_LATE_CANCEL: 'Transport annulé',
    HPTL_FLAG_PTNT_CANCEL: 'Transport annulé par le patient',
    HPTL_FLAG_PTNT_CANCEL_TO_VERIFY: 'Transport annulé par le patient',
    TPTR_FLAG_ORDER_ERROR: 'Erreur dans la commande',
    TPTR_FLAG_PTNT_LEFT: 'Déplacement inutile : le patient était déjà parti',
    TPTR_FLAG_PTNT_UNCOMPAT: "Déplacement inutile : l'état du patient n'est pas compatible avec un TAP",
    TPTR_FLAG_RDV_MISS: 'Arrivé trop tard pour le RDV du patient',
    TPTR_FLAG_VEHICLE_UNAVAILABLE: 'Véhicule indisponible ou en panne',
    TPTR_FLAG_DOCUMENTS_NOTREADY: 'Bon de transport ou autres documents non prêts',
    TPTR_FLAG_PTNT_NOTREADY: "Transport retardé : le patient n'était pas prêt à sortir",
    TPTR_FLAG_NO_RIDE_PTNT_NOTREADY: "Transport non effectué: le patient n'était pas prêt à sortir",
    TPTR_FLAG_LATE_CANCEL: 'Transport annulé sur place',
    TPTR_FLAG_NO_RETURN_RIDE: 'Trajet retour non effectué',
    TPTR_FLAG_OTHER: 'Autre raison',
    TPTR_FLAG_DUPLICATED_ORDER: 'Le transport est présent en double dans le logiciel Ambler',
    TPTR_FLAG_PICKUP_TIME_CHANGE: "Modification d'heure de prise en charge",
    TPTR_FLAG_WAITING_FOR_DOCUMENTS: 'En attente du bon de transport',
    TPTR_FLAG_ADD_COMMENT: "Ajout d'un commentaire",
    TPTR_FLAG_ADDRESS_OR_DATE_CHANGE: "Modification d'adresse et/ou de date",
    TPTR_FLAG_VEHICLE_CHANGE: 'Modification de véhicule',
    TPTR_FLAG_WRONG_DOCUMENTS: 'Mauvais bon de transport reçu',
    TPTR_FLAG_SUGGEST_PAYER_CHANGE: "Correction demandée par le MT sur l'établissement facturable ",
    TPTR_FLAG_TRIP_DELEGATED: 'Trajet délégué à une autre société',
    TPTR_FLAG_PATIENT_NOT_READY_FOR_DISCHARGE: 'Transport retardé',
    TPTR_FLAG_ORDER_MISSING_INFORMATION: 'Informations manquantes dans la commande du transport',
    TPTR_FLAG_WAITING_FEE_REQUESTED: "Nécessité d'attendre le patient sur place : demande d'ajout d'un forfait d'attente",
    TPTR_FLAG_PTNT_CANCEL: 'Transport annulé par le patient',
    TPTR_FLAG_PTNT_CANCEL_TO_VERIFY: 'Transport annulé par le patient',
};
//# sourceMappingURL=label.js.map